import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication-service/authentication.service';
import { HttpHelperService } from 'src/app/services/http-helper/http-helper.service';
import { Auth0Service } from '../services/auth0-service/auth0.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private httpHelperService = inject(HttpHelperService);
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);
  private auth0Service = inject(Auth0Service);

  canActivate(): Observable<boolean> {
    return this.authenticationService.isAccessTokenValid().pipe(
      take(1), // Only take the latest value and complete
      switchMap((loggedIn) => {
        if (!loggedIn) {
          // Save redirect URL
          const redirectUrl = window.location.pathname + window.location.search;
          sessionStorage.setItem('redirectUrl', redirectUrl);

          // Navigate to login
          this.auth0Service.login();

          return of(false); // Block navigation
        }

        // Logged in → allow navigation
        return of(true);
      }),
    );
  }
}
